// extracted by mini-css-extract-plugin
module.exports = {"stock":"CartProductStock_stock__XbSzF","unavailable":"CartProductStock_unavailable__2l1W3"};